import { LogoMark } from "./Logo";
import { useLang } from "../../lib/i18n";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center">
    {words.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-5xl md:text-7xl ${i % 2 ? "sw-outline italic" : "text-[#F4EFE6]"}`}>{w}</span>
        <LogoMark className="h-8 w-auto text-[#E6D9BC] md:h-10" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-[#E6D9BC]/15 bg-[#162026] py-8 md:py-10">
    <div className="sw-marquee flex w-max">
      <Row words={t.marquee} />
      <Row words={t.marquee} />
    </div>
  </div>
  );
};
